import { Component, Input, HostBinding } from '@angular/core';
import { Router } from '@angular/router';
import { SystemContextService } from '@app/core/services/system-context.service';

export interface CardAnimatedItem {
    routerLink: string | any[];
    imgSrc: string;
    imgAlt: string;
    title: string;
    description: string;
    buttonText: string;
    buttonIcon?: string;
    /** Contexto opcional para fijar system/module/submodule al navegar */
    contextSystem?: string | null;
    contextModuleId?: string | null;
    contextSubmoduleId?: string | null;
}

@Component({
    selector: 'app-card-animated',
    standalone: false,
    templateUrl: './card-animated.component.html',
    styleUrl: './card-animated.component.scss',
})
export class CardAnimatedComponent {
    @Input() item!: CardAnimatedItem;

    constructor(
        private router: Router,
        private systemContext: SystemContextService
    ) {}

    loading = true;

    get isExternalLink(): boolean {
        return typeof this.item?.routerLink === 'string' && /^https?:\/\//i.test(this.item.routerLink);
    }

    onImgLoad() {
        this.loading = false;
    }

    async onCardClick(event: MouseEvent) {
        if (!this.item?.routerLink) return;

        const link = this.item.routerLink;

        // Enlaces externos en nueva pestaña
        if (this.isExternalLink) {
            event.preventDefault();
            const url = link as string;
            window.open(url, '_blank');
            return;
        }

        // Navegación interna
        event.preventDefault();
        // Antes de navegar, fijamos el contexto si viene en la tarjeta
        if (this.item.contextSystem) {
            this.systemContext.setSystem(this.item.contextSystem as any, this.item.contextModuleId ?? null);
        }
        if (this.item.contextModuleId) {
            this.systemContext.setModule(this.item.contextModuleId);
        }
        if (this.item.contextSubmoduleId) {
            this.systemContext.setSubmodule(this.item.contextSubmoduleId);
        }
        if (Array.isArray(link)) {
            await this.router.navigate(link);
        } else if (typeof link === 'string') {
            await this.router.navigateByUrl(link);
        }
    }

    /** Personalizo clases de botón según tu sistema de colores */
    getButtonClasses(): string {
        return 'text-blue-500 dark:text-blue-300 group-hover:text-white';
    }

    @HostBinding('style.pointer-events') get pointer() {
        return this.item?.routerLink ? 'auto' : 'none';
    }

}
